import { useState } from "react";
import { Link } from "react-router-dom";
import { GetStartedModal } from "./GetStartedModal";

interface CTASectionProps {
  title?: string;
  primaryButtonText?: string;
  primaryButtonOnClick?: () => void;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

export const CTASection = ({
  title = "You're one step away from an amazing experience",
  primaryButtonText = "List A Property",
  primaryButtonOnClick,
  secondaryButtonText = "Browse Properties",
  secondaryButtonLink = "/explore/",
}: CTASectionProps) => {
  const [showGetStartedModal, setShowGetStartedModal] = useState(false);

  const handlePrimaryButtonClick = () => {
    if (primaryButtonOnClick) {
      primaryButtonOnClick();
    } else {
      setShowGetStartedModal(true);
    }
  };

  return (
    <>
      <section className="py-5">
        <div className="container text-center">
          <h4 className="fw-semibold">{title}</h4>
          <div className="d-grid gap-3 d-md-block my-4">
            {primaryButtonOnClick ? (
              <button
                onClick={primaryButtonOnClick}
                className="btn btn-custom-primary py-3 px-4 rounded-pill me-2 fs-14 fw-600"
              >
                {primaryButtonText}
              </button>
            ) : (
              <button
                onClick={handlePrimaryButtonClick}
                className="btn btn-custom-primary py-2 px-4 rounded-pill me-2 fs-14 fw-600"
              >
                {primaryButtonText}
              </button>
            )}
            <Link
              to={secondaryButtonLink}
              className="btn border-primary text-primary  py-2 px-3 rounded-pill fs-14 fw-600"
            >
              {secondaryButtonText}
            </Link>
          </div>
        </div>
      </section>
      <GetStartedModal
        show={showGetStartedModal}
        onClose={() => setShowGetStartedModal(false)}
      />
    </>
  );
};
